import React from 'react';
import styled from 'styled-components';

interface SelectableListProps {
    items: { id: string; label?: string }[];
    onClick: (id: string) => void;
    style?: React.CSSProperties;
    onHoverItem?: (id: string) => void;
    offHoverItem?: (id: string) => void;
}
export const SelectableList = ({ items, onClick, onHoverItem, offHoverItem, style = {} }: SelectableListProps) => {
    return (
        <div
            style={{
                borderRadius: 8,
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
                backgroundColor: 'white',
                border: '1px solid #888',
                minWidth: 240,
                maxHeight: 240,
                overflowY: 'scroll',
                zIndex: 1001,
                ...style,
            }}
        >
            {items.map((item) => {
                return (
                    <SelectItem
                        key={item.id}
                        style={{ flex: 1 }}
                        onClick={() => {
                            onClick(item.id);
                        }}
                        onMouseEnter={() => {
                            onHoverItem?.(item.id);
                        }}
                        onMouseLeave={() => {
                            offHoverItem?.(item.id);
                        }}
                    >
                        {item.label}
                    </SelectItem>
                );
            })}
        </div>
    );
};

const SelectItem = styled.div`
    flex: 1;
    padding: 4px 8px;
    text-align: left;

    :hover {
        background-color: #857dff;
        cursor: pointer;
        font-weight: bold;
        color: white;
    }
`;
